module.exports = __webpack_public_path__ + "static/media/1.7aaf8ce9.JPG";